export default __webpack_public_path__ + "static/media/precursor.7dea05b3.svg";